export type ClientBrainFieldType = "short_text" | "long_text" | "single_choice" | "multi_choice" | "checkbox" | "date" | "signature";

export type ClientBrainSectionKind = "fields" | "goals" | "risks";

export interface ClientBrainField {
    id: string;
    label: string;
    description: string;
    field_type: ClientBrainFieldType;
    options: string[];
    required: boolean;
}

export interface ClientBrainSection {
    id: string;
    title: string;
    description: string;
    kind: ClientBrainSectionKind;
    fields: ClientBrainField[];
}

export interface ClientBrainTemplate {
    id: string;
    title: string;
    sections: ClientBrainSection[];
}

export interface ClientBrainDocument {
    schema_version: number;
    draft: ClientBrainTemplate | null;
    published: ClientBrainTemplate | null;
    published_at: number | null;
    published_by: string | null;
    updated_at: number | null;
    updated_by: string | null;
}

export interface ClientBrainGoalAction {
    id: string;
    description: string;
    responsible: string;
    timeframe: string;
}

export type ClientBrainGoalStatus = "active" | "achieved" | "closed";

export interface ClientBrainGoal {
    id: string;
    title: string;
    description: string;
    methods: string;
    signs: string;
    status: ClientBrainGoalStatus;
    actions: ClientBrainGoalAction[];
}

export interface ClientBrainRisk {
    id: string;
    title: string;
    description: string;
}

export type ClientBrainValue = string | string[] | boolean;

export interface ClientBrainInstance {
    version?: number;
    schema_version: number;
    template_id: string | null;
    template_published_at: number | null;
    values: Record<string, ClientBrainValue>;
    goals: Record<string, ClientBrainGoal[]>;
    risks: Record<string, ClientBrainRisk[]>;
    updated_at: number | null;
    updated_by: string | null;
}

export interface ClientBrainBuilderMessage {
    role: string;
    content: string;
}

export const CLIENT_BRAIN_FIELD_TYPES: ClientBrainFieldType[] = ["short_text", "long_text", "single_choice", "multi_choice", "checkbox", "date", "signature"];

export const CLIENT_BRAIN_SECTION_KINDS: ClientBrainSectionKind[] = ["fields", "goals", "risks"];

export const CLIENT_BRAIN_GOAL_STATUSES: ClientBrainGoalStatus[] = ["active", "achieved", "closed"];

export const EMPTY_CLIENT_BRAIN_DOCUMENT: ClientBrainDocument = {
    schema_version: 1,
    draft: null,
    published: null,
    published_at: null,
    published_by: null,
    updated_at: null,
    updated_by: null
};

export const emptyClientBrainInstance = (): ClientBrainInstance => ({
    schema_version: 1,
    template_id: null,
    template_published_at: null,
    values: {},
    goals: {},
    risks: {},
    updated_at: null,
    updated_by: null
});
